








import {defineComponent, PropType} from '@vue/composition-api'

import {IVideo} from '../../models/video'

import VideoPlayerWidget from '@/apps/VideoPlayerWidget/components/VideoPlayerWidget.vue'
import {useState} from 'vuex-composition-helpers'

export default defineComponent({
  name: 'VideoComponent',
  components: {
    VideoPlayerWidget
  },
  props: {
    asset: {
      type: Object as PropType<IVideo>,
      required: true
    }
  },
  setup: () => {
    const {config} = useState(['config'])

    return {
      config
    }
  }
})
